import { useTheme } from "@mui/material"

const useStyles = () => {
  const { breakpoints } = useTheme()
  return {
    main: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [breakpoints.up(900)]: {
        paddingLeft: 1,
      },
      [breakpoints.down(900)]: {
        paddingLeft: '0px',
      },
    },
    aplly: {
      backgroundColor: 'primary.100',
      height: '50px',
      padding: '5px 25px',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: 'primary.100',
      }
    },
    btn: {
      fontSize: '.8rem'
    },
    children: {
      alignContent: 'center',
      [breakpoints.up(900)]: {
        paddingRight: '16px',
      },
      [breakpoints.down(900)]: {
        paddingRight: '0px',
        marginBottom:3,
      },
    }
  }
}

export { useStyles }